module.exports = __webpack_public_path__ + "static/img/report3d_function03.eea4eeff.png";